import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { Button, createUseStyles, Text, Icon, useTheme, Link } from 'hoi-poi-ui';
import { useWeb5Context } from "../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'TourTooltip');
const TourTooltip = /*#__PURE__*/memo(_ref => {
  let {
    step,
    skipProps,
    primaryProps,
    tooltipProps,
    isLastStep
  } = _ref;
  const {
    t
  } = useWeb5Context();
  const classes = useStyles();
  const theme = useTheme();
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes.popover
  }, tooltipProps), /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Text, {
    type: "subtitle"
  }, step.title), /*#__PURE__*/React.createElement(Icon, _extends({
    name: "close",
    color: theme.colors.primary.white
  }, skipProps))), step.content && /*#__PURE__*/React.createElement(Text, {
    type: "caption"
  }, step.content), /*#__PURE__*/React.createElement("div", {
    className: classes.bottom
  }, step.link && /*#__PURE__*/React.createElement(Link, {
    className: classes.link,
    type: "caption",
    href: step.link,
    target: "_blank"
  }, t('label_learn_more')), /*#__PURE__*/React.createElement(Button, _extends({
    size: "small",
    type: "terciary",
    className: classes.button
  }, primaryProps), isLastStep && t('action_promotion_got_it'), !isLastStep && t('action_next'))));
});
export default TourTooltip;